/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Contact_Not_ErasableInputs */

const en_error_contact_not_erasable = /** @type {(inputs: Error_Contact_Not_ErasableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This contact was erased on request: it can't be changed or brought back.`)
};

/**
* | output |
* | --- |
* | "This contact was erased on request: it can't be changed or brought back." |
*
* @param {Error_Contact_Not_ErasableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_contact_not_erasable = /** @type {((inputs?: Error_Contact_Not_ErasableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Contact_Not_ErasableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_contact_not_erasable(inputs)
});